import { render, staticRenderFns } from "./DataDownload.vue?vue&type=template&id=f47cb344&scoped=true"
import script from "./DataDownload.vue?vue&type=script&lang=js"
export * from "./DataDownload.vue?vue&type=script&lang=js"
import style0 from "./DataDownload.vue?vue&type=style&index=0&id=f47cb344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47cb344",
  null
  
)

export default component.exports